import React from "react"
import { cn } from "../../utils/cn"

const VARIANTS = {
  default: "bg-accent text-accent-foreground",
  secondary: "bg-muted text-muted-foreground",
  success: "bg-success/10 text-success",
  warning: "bg-warning/10 text-warning",
  destructive: "bg-destructive/10 text-destructive",
  outline: "border border-border text-foreground",
}

export const Badge = React.forwardRef(({ className, variant = "default", ...props }, ref) => (
  <span
    ref={ref}
    data-slot="badge"
    className={cn(
      "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap",
      VARIANTS?.[variant] || VARIANTS.default,
      className
    )}
    {...props}
  />
))
Badge.displayName = "Badge"